import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Bloqueio de Usuario',
  path: '/biblioteca/bibusuariobloqueio',
  name: 'bibusuariobloqueio',
  component: () => import('@/views/biblioteca/bibusuariobloqueio/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.BIB_BLOQUEIODESBLOQUEIONOVO_MENU_1300300399],
  },
  goesToMenu: true,
 },
 {
  description: 'Área de Interesse do Usuario',
  path: '/biblioteca/bibusuarioareainteresse',
  name: 'bibusuarioareainteresse',
  component: () => import('@/views/biblioteca/bibusuarioareainteresse/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.BIB_AREADEINTERESSEUSUARIONOVO_MENU_1300300299],
  },
  goesToMenu: true,
 },
 
]
